import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';

@NgModule({
  imports: [StoreModule.forFeature('shellMainNav', reducer)]
})
export class StateModule {}
